<template>
  <div class="to-quote-container">
    <el-table :data="requirementList"
              size="mini"
              style="width: 100%">
      <el-table-column prop="itemName"
                       label="物料名称"
                       width="250">
      </el-table-column>
      <el-table-column prop="itemCode"
                       label="物料编码"> </el-table-column>
      <el-table-column prop="brandName"
                       label="品牌"> </el-table-column>
      <el-table-column prop="modelName"
                       label="机型"
                       width="150">
      </el-table-column>
      <el-table-column prop="moduleName"
                       label="模块"> </el-table-column>
      <el-table-column label="品项">
        <template slot-scope="scope">
          <el-tag :type="scope.row.qualityName | qualityType"
                  size="mini">
            {{ scope.row.qualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity"
                       label="数量"> </el-table-column>
      <el-table-column prop="dueDate"
                       label="到期日"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.dueDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="产品图片"
                       width="100">
        <template slot-scope="scope">
          <el-image :src="`http://www.spr-atm.com/Seller/ShowImage?code=${scope.row.itemCode}`"
                    :preview-src-list="previewFiles(scope.row.itemCode)"
                    style="width:40px; height:40px">
            <div slot="error"
                 class="image-slot">
              <img src="@images/watermark.jpg"
                   style="width: 40px; height: 40px;"
                   alt="" />
            </div>
          </el-image>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      requirementList: [],
      isLoading: false
    };
  },
  created () {
    this.getRequirementList()
  },
  methods: {
    async getRequirementList () {
      this.isLoading = true
      const params = {
        materialName: '',
        brand: '',
        model: '',
        module: '',
        quoteQuality: '',
        state: '待报价',
        skipCount: 0,
        maxResultCount: 10
      }
      const res = await this.$http.get(
        '/api/services/inquiryApp/dIDetail/GetAll',
        params
      )
      this.requirementList = res.result.items
      this.isLoading = false
    },
    previewFiles (itemCode) {
      let arr = []
      arr.push(`http://www.spr-atm.com/Seller/ShowImage?code=${itemCode}`)
      return arr
    }
  }
}
</script>
<style lang="less" scoped>
.to-quote-container {
  height: 100%;
  overflow: hidden;
  padding: 20px;
}
.el-table {
  /deep/ th {
    .cell {
      color: #2f343c;
      font-size: 14px;
      line-height: 33px;
      font-weight: 600;
    }
  }
}
</style>